import qs from 'qs';

export const qsStringify = (
  query: any,
  options?: qs.IStringifyOptions | undefined
): string => {
  return qs.stringify(query, {
    encodeValuesOnly: true,
    ...options,
  });
};
